"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _compact = _interopRequireDefault(require("lodash/compact"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Join multiple classnames
 * Returns a string of joined classnames omitting falsy values, undefined when resulting string is empty
 */
function joinClassNames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  var result = (0, _compact.default)(classnames).join(' ');
  return result || undefined;
}

var _default = joinClassNames;
exports.default = _default;